import { Injectable } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { UstawieniaSystemuDto } from '@interfaces/administracja/systems/informacje-o-systemie.interface';
import { InformacjeOSystemieService } from '@services/api/administracja/systems/informacje-o-systemie.service';

@Injectable({
  providedIn: 'root',
})
export class SystemDataService {
  systemData: UstawieniaSystemuDto;

  constructor(
    private readonly informationAbousSystemService: InformacjeOSystemieService,
    private readonly sanitizer: DomSanitizer,
  ) {}

  getData(): void {
    this.informationAbousSystemService.getSystemSettings().subscribe((data) => {
      this.systemData = {
        ...data,
        logo: this.convertLogoBase64ToSafeUrl(data.logo as string),
      };
    });
  }

  private convertLogoBase64ToSafeUrl(base64Logo: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${base64Logo}`);
  }
}
